import { cn } from '@/lib/utils';

interface TimeOffStatusSwatchProps {
  /** Approved → solid fill; otherwise the pending diagonal-stripe pattern. */
  isApproved: boolean;
  className?: string;
}

/**
 * Small square swatch encoding time-off status the same way the calendar bars
 * do: a solid fill for approved, the diagonal stripe pattern for pending.
 * Shared by the week strip totals, the tooltip, and the details card so the
 * status legend stays consistent across the feature.
 */
export function TimeOffStatusSwatch({ isApproved, className }: TimeOffStatusSwatchProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-block h-2 w-2 shrink-0 rounded-sm border border-time-off-border',
        isApproved ? 'bg-time-off' : 'time-off-pending',
        className
      )}
    />
  );
}
